module.exports = __webpack_public_path__ + "static/img/2884_phase_function_Paper_PointsHejduk_Prediction.176e1be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2884_phase_function_Paper_PointsHejduk_Prediction.png
// module id = cC64
// module chunks = 0